<template>  
    <div style="height:50vh">
       <header>
       <van-field
        v-model="goodCode"
        center
        @focus='skuFocus'
        @input='skuInput'
        left-icon="search"
        clearable   
        placeholder="请输入商品名称"
        >
            <template #button>
              <span @click="cancle" >取消</span>
              <span @click="save" style="margin-left:7px;color:#74B42B">保存</span>
            </template>
            </van-field>
        </header>
        <div v-if="skuShow" class="sku_ul">
            <ul v-if="skuList.length" ref="ul"  >
                <li @click="skuClassChange(index,item)" v-for="(item,index) in skuList" :key="item.skuId">{{item.goodsName}}-{{item.skuName}}</li>
            </ul>
            <div  v-else>
                <img src="@/assets/搜索.png" alt class="noList" />
                <p class="search-p" style="text-align:center">暂无搜索结果</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    main: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  data() {
    return {
      goodCode: "",
      skuShow: false,
      customerId: "",
      currentItem: {},
      skuList: []
    };
  },
  created() {
    this.customerId = localStorage.getItem("customerId");
  },
  methods: {
    cancle() {
      this.$emit("close");
    },
    save() {
      if (this.currentItem.salePrice == null)
        return this.$toast.error("该商品已失效");

      this.$dialog
        .confirm({
          title: "提示",
          message: "确认保存？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          this.currentItem = {
            parameter: "",
            classifyValue: this.main ? 0 : 1,
            classifyLabel: this.main ? "主料商品" : "辅料商品",
            ...this.currentItem
          };
          this.$emit("confirm", this.currentItem);
        })
        .catch(() => {
          // on cancel
        });
    },
    skuFocus() {
      this.skuShow = true;
    },
    skuClassChange(index, item) {
      if (!this.$refs.ul) return;
      let eles = this.$refs.ul.childNodes;
      eles.forEach((item, i) => {
        if (i == index) item.className = "active";
        else item.className = "";
      });
      this.currentItem = item;
    },
    skuBlur() {
      this.skuShow = false;
    },
    getSkuList(param) {
      let obj = {
        param,
        deliveryTime: Date.now() + 24 * 60 * 60 * 1000,
        customerId: +this.customerId
      };
      this.$axios.post("trade/tradeOrder/searchSku/price", obj).then(res => {
        this.skuList = res.data.data;
        this.$nextTick(() => {
          this.skuClassChange(0, this.skuList[0]);
        });
      });
    },
    skuInput(value) {
      if (!value) return (this.skuList = []);
      this.getSkuList(value);
    }
  }
};
</script>

<style lang='scss'   scoped>
/deep/ .van-field {
  border-bottom: 1px solid #979797;
  color: #333;
  font-size: 14px;
}
.sku_ul {
  padding: 15px;
  height: 80%;
  font-size: 14px;
  overflow-y: auto;
  color: #777777;
  li {
    margin-bottom: 8px;
    &.active {
      color: #74b42b;
    }
  }
}
.noList {
  width: 100%;
  height: 100%;
}
</style>
 